// Localização: frontend/src/hooks/useDiarioCuidados.js (versão 0.1.6)
// Remoção da lógica de concluirTarefa

import { useState, useCallback } from 'react';
import api from '../api/api';

/**
 * Hook personalizado para gerenciar o estado e operações do Diário de Cuidados.
 * @param {string} pacienteId - O ID do paciente cujos registros estão sendo gerenciados.
 */
export function useDiarioCuidados(pacienteId) {
    const [registros, setRegistros] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // 1. Função para buscar os registros (MANTIDA)
    const fetchRegistros = useCallback(async () => {
        if (!pacienteId) return;

        setIsLoading(true);
        setError(null);
        try {
            const response = await api.get(`/diario/paciente/${pacienteId}`); 
            // 🛑 NOTA: A estrutura do retorno deve estar ok com a correção do backend (campo 'conteudo_detalhado')
            setRegistros(response.data); 
        } catch (err) {
            console.error('Erro ao buscar registros do diário:', err);
            setError('Falha ao carregar registros do diário. Verifique a conexão com o servidor.');
            setRegistros([]);
        } finally {
            setIsLoading(false);
        }
    }, [pacienteId]);


    // 3. Função para salvar (criar) um novo registro manual (CORRIGIDA)
    // Os dados esperados são: { tipo_registro, observacoes, conteudo_detalhado, turno }
    const createRegistro = useCallback(async (novoRegistroData) => {
        setIsLoading(true);
        setError(null);
        try {
            // 🛑 CORREÇÃO: Mapeando os campos para o que o backend espera.
            // O frontend (RegistroMedicacaoModal) estava enviando: { tipo_registro, conteudo, observacoes }
            // O backend espera: { tipo_registro, observacoes, conteudo_detalhado }
            
            const payload = {
                paciente_id: pacienteId,
                tipo_registro: novoRegistroData.tipo_registro,
                observacoes: novoRegistroData.observacoes || null, // Observação geral
                // O 'conteudo' do modal é o 'conteudo_detalhado' do backend
                conteudo_detalhado: novoRegistroData.detalhes, // Será stringificado no backend se for objeto
                turno: novoRegistroData.turno || null, // Se o modal enviar turno
            };
            
            // O endpoint é /api/diario
            const response = await api.post('/diario', payload);

            // Adiciona o novo registro (com o nome do profissional e data simulados do backend)
            setRegistros(prev => [response.data, ...prev]);
            setIsLoading(false);
            return true;
        } catch (err) {
            console.error('Erro ao criar registro no diário:', err.response?.data || err);
            const errorMessage = err.response?.data?.message || 'Falha ao criar o registro de cuidado.';
            setError(errorMessage);
            setIsLoading(false);
            return false;
        }
    }, [pacienteId]);
    
    
    return {
        registros,
        isLoading,
        error,
        fetchRegistros,
        createRegistro,
        setError, 
    };
}